import React from "react";
import { Typography } from "antd";
import BackButton from "./BackButton";

const { Text } = Typography;

interface NotFoundViewProps {
  isMeshRoute: boolean;
  onGoBack: () => void;
}

const NotFoundView: React.FC<NotFoundViewProps> = ({
  isMeshRoute,
  onGoBack,
}) => (
  <div className="p-6">
    <BackButton onClick={onGoBack} />
    <div className="mt-6 flex justify-center">
      <Text type="danger" className="text-center">
        {isMeshRoute ? "Mesh" : "Specimen"} not found.
      </Text>
    </div>
  </div>
);

export default NotFoundView;
